/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_License_GcInputs */

const en_gc_resources_compare_license_gc = /** @type {(inputs: Gc_Resources_Compare_License_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source: MIT / Apache 2.0`)
};

const zh_gc_resources_compare_license_gc = /** @type {(inputs: Gc_Resources_Compare_License_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源：MIT / Apache 2.0`)
};

/**
* | output |
* | --- |
* | "Open source: MIT / Apache 2.0" |
*
* @param {Gc_Resources_Compare_License_GcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_license_gc = /** @type {((inputs?: Gc_Resources_Compare_License_GcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_License_GcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_license_gc(inputs)
	return zh_gc_resources_compare_license_gc(inputs)
});
export { gc_resources_compare_license_gc as "gc.resources.compare.license.gc" }